
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("dPS3E"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("1scmV"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdRAKS _42Yu6BsWIj",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $cozmU.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $cozmU.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("dPS3E", function(module, exports) {

let $a129f88ad1bb7bc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a129f88ad1bb7bc0$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("1scmV", function(module, exports) {

let $10f20022e50555c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $10f20022e50555c5$var$load("3DhvF"),
    $10f20022e50555c5$var$load("3uoZx"),
    $10f20022e50555c5$var$load("aNbx0"),
    $10f20022e50555c5$var$load("fDw1T"),
    $10f20022e50555c5$var$load("goqC1"),
    $10f20022e50555c5$var$load("60QcS"),
    $10f20022e50555c5$var$load("husez"),
    $10f20022e50555c5$var$load("hUbK8"),
    $10f20022e50555c5$var$load("2aRCy"),
    $10f20022e50555c5$var$load("72WVV"),
    $10f20022e50555c5$var$load("5KHgm"),
    $10f20022e50555c5$var$load("aIZwI"),
    $10f20022e50555c5$var$load("3i6cl"),
    $10f20022e50555c5$var$load("iOfkQ"),
    $10f20022e50555c5$var$load("juqSe"),
    $10f20022e50555c5$var$load("jZ894"),
    $10f20022e50555c5$var$load("16zlP"),
    $10f20022e50555c5$var$load("d3coG"),
    $10f20022e50555c5$var$load("upHOT"),
    $10f20022e50555c5$var$load("kccW9"),
    $10f20022e50555c5$var$load("F9WGX"),
    $10f20022e50555c5$var$load("eeYoU"),
    $10f20022e50555c5$var$load("do0Fh"),
    $10f20022e50555c5$var$load("cmmpX"),
    $10f20022e50555c5$var$load("fEHF5"),
    $10f20022e50555c5$var$load("4XoWv"),
    $10f20022e50555c5$var$load("2PVCX"),
    $10f20022e50555c5$var$load("jqoep"),
    $10f20022e50555c5$var$load("6wr18"),
    $10f20022e50555c5$var$load("59hV4"),
    $10f20022e50555c5$var$load("8T2wY"),
    $10f20022e50555c5$var$load("cFgVe"),
    $10f20022e50555c5$var$load("5wzAc"),
    $10f20022e50555c5$var$load("aMsb0"),
    $10f20022e50555c5$var$load("2PXrC"),
    $10f20022e50555c5$var$load("3g5Gh"),
    $10f20022e50555c5$var$load("eIINb"),
    $10f20022e50555c5$var$load("eqj21"),
    $10f20022e50555c5$var$load("3oAU3"),
    $10f20022e50555c5$var$load("a8glC"),
    $10f20022e50555c5$var$load("1I2Ka"),
    $10f20022e50555c5$var$load("bFOJi"),
    $10f20022e50555c5$var$load("ccAQf"),
    $10f20022e50555c5$var$load("4x9Jx"),
    $10f20022e50555c5$var$load("ea3NB"),
    $10f20022e50555c5$var$load("8B3mf"),
    $10f20022e50555c5$var$load("a6GGe"),
    $10f20022e50555c5$var$load("6vqGz"),
    $10f20022e50555c5$var$load("ffEVr"),
    $10f20022e50555c5$var$load("eLfJM"),
    $10f20022e50555c5$var$load("iMohY"),
    $10f20022e50555c5$var$load("3SirY"),
    $10f20022e50555c5$var$load("Wowvf"),
    $10f20022e50555c5$var$load("2l8zo"),
    $10f20022e50555c5$var$load("20jHp"),
    $10f20022e50555c5$var$load("gygr6"),
    $10f20022e50555c5$var$load("hhss7"),
    $10f20022e50555c5$var$load("aAWLw"),
    $10f20022e50555c5$var$load("7EorR"),
    $10f20022e50555c5$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.63e50b14.js.map
